import { render, staticRenderFns } from "./ServerPerformance.vue?vue&type=template&id=55cf2a30&"
import script from "./ServerPerformance.vue?vue&type=script&lang=js&"
export * from "./ServerPerformance.vue?vue&type=script&lang=js&"
import style0 from "./ServerPerformance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports